export enum BudgetComparison {
    DEMAND_ACTUAL = 'demandActual',
    SCHEDULED_ACTUAL = 'scheduledActual',
    DEMAND_SCHEDULED = 'demandScheduled',
    TOTAL_VS_DEMAND = 'totalVsDemand'
}
